<div class="page" style=" font-family: f600;" dir="rtl" >
<div style=" margin-bottom: 20px; ">

  <!-- 

כאן הסקרול למעלה -->
<!-- ______________________________________________________ -->
  <div class="m-auto widthPage"  >
     <div class="d-flex m-auto" style="padding-bottom: 10px;" >
      <mat-spinner *ngIf="!categoresItemLastMenu?.length" class="mat-spinner-color" style=" justify-content: center; 
        align-items: center; margin:0 auto;" [diameter]="70" mode="indeterminate"></mat-spinner>
      <ngb-carousel *ngIf="categoresItemLastMenu?.length">
        <ng-template ngbSlide *ngFor="let ca of categoresItemLastMenu; let i = index" >
          <div class="d-flex" (click)="imgSlide(i)" style="direction: rtl; cursor: pointer; margin-top: 10px;">
                
                  <img class="carousel-image-wrapper" [src]="ca.ImageFile" alt="" />
              
            </div>
          </ng-template>
       </ngb-carousel>
     </div>
  </div>
     <!-- </div> -->
  <div class="m-auto widthPage" *ngFor="let mainObject of mainListObject ;let i = index" >




        <mat-spinner *ngIf="showProgress==true" class="mat-spinner-color" style=" justify-content: center; 
        align-items: center; margin:0 auto;" [diameter]="70" mode="indeterminate"></mat-spinner>



     <!-- ______________________________________________________ -->

     <!-- קטגוריות -->
      <!-- ______________________________________________________ -->
      <div class="category-group" *ngIf="mainObject.IsCategories==1">
        <div class="category-header">
          <span class="name" style="color: black; margin-right: 2px;">{{mainObject.ListName}}</span>
          <div class="slider-controls" >
            <button 
              (click)="slideLeft(i)" 
              [disabled]="!canSlideLeft(i)"
              class="slider-button right-arrow "
            >
              <i class="fas fa-chevron-left"></i>
            </button>
            <button 
              (click)="slideRight(i)" 
              [disabled]="!canSlideRight(i)"
              class="slider-button left-arrow "
            >
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>

        </div>
      
        <div class="categories-wrapper">
          <div class="categories-slider"  [style.transform]="'translateX(' + getSliderPosition(i) + 'px)'">
            <div *ngFor="let item of mainObject.categories; let ind = index" 
                 class='category-item'
                 [style.width.px]="226">
              <app-category-item 
                (change)="ngOnInit()" 
                [categoryItem]="item"
                [listId]="mainObject.ListID"
              ></app-category-item>
            </div>
          </div>
        </div>
      </div>
<!-- ______________________________________________________ -->
<!-- Restaurants -->

<div class="restaurant-group" *ngIf=" mainObject.IsCategories==0">
  <div class="restaurant-header">
    <span class="name" style="color: black; margin-right: 2px;">{{mainObject.ListName}}</span>
    <div class="slider-controls right-arrow" >
      <button 
        (click)="slideRestaurantLeft(i)" 
        [disabled]="!canRestaurantSlideLeft(i)"
        class="slider-button right-arrow "
      ></button>
      <button 
        (click)="slideRestaurantRight(i)" 
        [disabled]="!canRestaurantSlideRight(i)"
        class="slider-button left-arrow "
      ></button>
    </div>

  </div>

  <div class="restaurants-wrapper">
    <div class="restaurants-slider" [style.transform]="'translateX(' + getRestaurantSliderPosition(i) + 'px)'">
      <div *ngFor="let item of mainObject.list; let ind = index" 
           class="restaurant-item"
           [style.width.px]="restaurantItemWidth">
        <app-resraurant-item
          (change)="ngOnInit()" 
          [mainRestaurantItem]="item" 
         
          [indexList]="mainObject.ListID"
        ></app-resraurant-item>
      </div>
    </div>
  </div>
</div>
     </div>  
 </div>
 </div>



